import { type ReactElement, type PropsWithChildren } from 'react';

import { Link } from '@beeline/lk-utils';

import clsx from 'clsx';

import styles from './styles.module.scss';
import type { Help } from './types';

export const HelpButtonOrLink = ({
  helpUrl,
  helpButtonOnclick,
  children,
}: PropsWithChildren<Help>): ReactElement => {
  if (helpUrl) {
    return (
      <Link
        to={helpUrl}
        disableTextDecoration
        noWrapper
        className={clsx(styles.help, styles.link)}
      >
        {children}
      </Link>
    );
  }

  return (
    <button
      className={clsx(styles.help, styles.button)}
      onClick={helpButtonOnclick}
    >
      {children}
    </button>
  );
};
